let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("124it")).then(() => parcelRequire('3ntz2'));